import styled from 'styled-components';

export const TextSmall = styled.span`
  color: ${({ $gray }) => ($gray ? 'var(--greyscale-shade)' : 'var(--greyscale-blackish)')};
  font-size: var(--font-size-small);
  font-weight: ${({ $bold }) => ($bold ? 'var(--font-weight-medium)' : 'var(--font-weight-regular)')};
  line-height: var(--font-line-height-small);
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextMediumSmall = styled.span`
  color: ${({ $gray }) => ($gray ? 'var(--greyscale-shade)' : 'var(--greyscale-blackish)')};
  font-size: var(--font-size-medium);
  font-weight: ${({ $bold }) => ($bold ? 'var(--font-weight-medium)' : 'var(--font-weight-regular)')};
  line-height: var(--font-line-height-regular);
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextRegular = styled.span`
  color: ${({ $gray }) => ($gray ? 'var(--greyscale-shade)' : 'var(--greyscale-blackish)')};
  font-size: var(--font-size-regular);
  font-weight: ${({ $bold }) => ($bold ? 'var(--font-weight-medium)' : 'var(--font-weight-regular)')};
  line-height: var(--font-line-height-regular);
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
